/**
 * Konvertiert einen String in einen URL-freundlichen Slug-Format
 */
export function slugify(text: string): string {
  return text
    .toString()                     // String umwandeln für den Fall, dass es keiner ist
    .toLowerCase()                  // In Kleinbuchstaben umwandeln
    .normalize('NFD')               // Akzente zu ihren Basis-Buchstaben + Akzent-Zeichen trennen
    .replace(/[\u0300-\u036f]/g, '') // Akzent-Zeichen entfernen
    .replace(/[^a-z0-9\-]/g, '-')   // Nicht-alphanumerische Zeichen durch Bindestriche ersetzen
    .replace(/\-\-+/g, '-')         // Mehrere Bindestriche durch einen Bindestrich ersetzen
    .replace(/^-+/, '')             // Führende Bindestriche entfernen
    .replace(/-+$/, '');            // Abschließende Bindestriche entfernen
}

/**
 * Formatiert eine Preisklasse als Euro-Symbole
 */
export function formatPriceRange(priceRange: number): string {
  return '€'.repeat(priceRange);
}

/**
 * Berechnet die Entfernung zwischen zwei geografischen Koordinaten
 */
export function calculateDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number
): number {
  const R = 6371; // Radius der Erde in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c; // Entfernung in km
  return d;
}

/**
 * Konvertiert Grad in Radian
 */
function deg2rad(deg: number): number {
  return deg * (Math.PI / 180);
}

/**
 * Formatiert ein Datumsobjekt als deutschen String
 */
export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
}